module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Icons/project-type-2-3b07023bdcf02e5d5fda40ecfb8b560e.svg";